import useScript from '@website/hooks/useScript';
import ErrorPage from './ErrorPage';
import LoadingPage from './LoadingPage';

type Props = {
  url: string;
  children: React.ReactNode;
};

export default function ScriptProvider({ url, children }: Props) {
  const [loaded, scriptLoadingError] = useScript(url);

  if (!loaded) {
    return <LoadingPage />;
  }

  if (scriptLoadingError) {
    return <ErrorPage />;
  }

  // load children
  return <>{children}</>;
}
